import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import React, { useMemo, useContext } from "react";
import { ThemeProvider as StyledThemeProvider, ThemeContext as StyledThemeContext, withTheme as withStyledTheme } from "styled-components";
import { THEMES, DEFAULT_THEME, addThemeHelpers } from "../utils/theme";
export var ThemeContext = StyledThemeContext;
export var useTheme = function useTheme() {
  return useContext(ThemeContext);
};
export var withTheme = withStyledTheme;

var ThemeProvider = function ThemeProvider(_ref) {
  var _ref$name = _ref.name,
      name = _ref$name === void 0 ? "light" : _ref$name,
      _ref$themes = _ref.themes,
      themes = _ref$themes === void 0 ? [] : _ref$themes,
      _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? "app" : _ref$mode,
      children = _ref.children;
  var theme = useMemo(function () {
    var matchTheme = [].concat(_toConsumableArray(THEMES), _toConsumableArray(themes)).find(function (theme) {
      return theme.name === name;
    }) || DEFAULT_THEME;
    return _objectSpread({
      mode: mode
    }, addThemeHelpers(matchTheme));
  }, [themes, mode, name]);
  return React.createElement(StyledThemeProvider, {
    theme: theme
  }, children);
};

export default ThemeProvider;